import {
    ConfirmCallback,
    EditedCallback,
    ElementsCallback,
    InformationResultCallback,
    InitCallback,
    MakingAdjustmentsCallback,
    MandatoryCallback,
    MetadataCallback,
    SelectionCallback,
    StepMetadata,
    StepSpecificStorageCallback,
    StorageCallback,
    ValidationCallback,
    WorkflowMetadata,
} from ".";
import { WorkflowManager, InformationResult, RegionElement, SpiffCommerceClient, WorkflowExperience } from "..";
import { CanvasCommand } from "../command";
import { CommandContext, CommandState } from "../CommandContext";
import { LayoutState, Product, SerializableStep, StepStorage, VariantResource } from "../types";
import { Poller } from "../util/Poller";

export class MockWorkflowManager implements WorkflowManager {
    updateRecipient(_firstName?: string, _lastName?: string, _address?: string, _suburb?: string, _state?: string, _email?: string, _postalCode?: string, _country?: string): Promise<void> {
        throw new Error("Method not implemented.");
    }
    approveTransaction(_note?: string): Promise<void> {
        throw new Error("Method not implemented.");
    }
    rejectTransaction(_note?: string): Promise<void> {
        throw new Error("Method not implemented.");
    }
    private client: SpiffCommerceClient | undefined;
    getClient(): SpiffCommerceClient {
        return this.client ?? ({} as any);
    }
    getWorkflowExperience(): WorkflowExperience {
        return {} as any;
    }
    setClient(client: SpiffCommerceClient) {
        this.client = client;
    }
    getInitializationPromise() {
        return Promise.resolve();
    }
    getProduct: () => Product;
    isInitialized(): boolean {
        return true;
    }
    getCommandContext: () => CommandContext;
    getAllLayoutData: () => LayoutState[];
    getMetadata: (stepName: string) => StepMetadata | undefined;
    getWorkflowMetadata: () => WorkflowMetadata;
    getStepStorage: (stepName: string) => StepStorage | undefined;
    getInformationResults(): InformationResult[] {
        return [];
    }
    async reset() {}
    updateStateWithServer(_getReducerState: () => CommandState) {}
    async outstandingRequestsPromise() {}
    async updateStateWithServerImmediate(_getReducerState: () => CommandState) {}
    addPoller(_poller: Poller) {}
    addConfirmCallback(_callback: ConfirmCallback) {}
    addEditedCallback(_callback: EditedCallback) {}
    addElementsCallback(_callback: ElementsCallback) {}
    addInformationResultCallback(_callback: InformationResultCallback) {}
    addInitCallback(_callback: InitCallback) {}
    addMakingAdjustmentsCallback(_callback: MakingAdjustmentsCallback) {}
    addMandatoryCallback(_callback: MandatoryCallback) {}
    addMetadataCallback(_callback: MetadataCallback) {}
    addSelectionCallback(_callback: SelectionCallback) {}
    addStepSpecificStorageCallback(_callback: StepSpecificStorageCallback, _stepName: string) {}
    addStorageCallback(_callback: StorageCallback) {}
    getCommandDispatcher() {
        return (_command: CanvasCommand) => {};
    }
    getLayouts() {
        return [];
    }
    getLayoutPreviewService() {
        return {
            getAll: () => {
                return new Map();
            },
        } as any;
    }
    getPreviewService() {
        return undefined;
    }
    setModelContainer: (container: any) => void;
    getModelContainer() {
        return undefined;
    }
    getProfanities() {
        return [];
    }
    getRegionElements(_stepName: string) {
        return [];
    }
    getSerializedStep(_stepName: string, _serializedSteps: SerializableStep[]) {
        return undefined;
    }
    getStepSpecificServices(_stepName: string) {
        return undefined;
    }
    getTransaction() {
        return {
            id: "",
        };
    }
    getTransactionCustomer() {
        return undefined;
    }
    setTransactionCustomer() {
        return;
    }
    setTransactionCustomerDetails() {
        return;
    }
    getWorkflow() {
        return {
            id: "",
            name: "",
            panels: [],
            steps: [],
            showModelOnFinishStep: false,
            allowProofDownload: false,
            introduction: "",
            stepGroups: [],
        };
    }
    markStepsAsInitialised(_stepNames: string[]) {}
    getUpdatesPending: () => boolean;
    markUpdateCompleted(_update: string) {}
    markUpdatePending() {
        return "123";
    }
    getWorkflowSelections() {
        return {};
    }
    getStepSelections() {
        return {};
    }
    setCurrentAdjustingStepId(_stepId: string) {}
    setEditedStatus(_stepName: string, _status: boolean) {}
    setInformationResults(_results: InformationResult[]) {}
    setMandatoryFulfilled(_stepName: string, _status: boolean) {}
    async setSelectionsAndElements(_stepName: string, _variants: VariantResource[], _elements: RegionElement[]) {}
    toggleDesignConfirmed() {}
    updateMetadata(_stepName: string, _update: any) {}
    async updateStorage(_stepName: string, _update: StepStorage) {}
    injectIntoPreviewService(_previewService: any): Promise<void> {
        return Promise.resolve();
    }
    ejectFromPreviewService(): void {}
    setWorkflowStateSyncEnabled(_enabled: boolean) {}
    async updateTransactionShareActions() {}
    addValidationCallback(_callback: ValidationCallback) {}
    setStepError(_stepName: string, _field: string, _error: string | undefined) {}
    getStepErrors(_stepName: string) {
        return undefined;
    }
    getValidationErrors() {
        return { steps: new Map() };
    }
    async updateTransactionStakeholders() {}
    getStepTags(_stepId: string): string[] {
        return [];
    }
}
